import sprite from '../assets/icons.svg?raw';

/**
 * The 29 icons, inlined into the document.
 *
 * `<use href="external.svg#id">` is not reliably supported across browsers for
 * a cross-document reference, and this page has no server to shim it, so the
 * sprite ships in the DOM the way it did in the standalone build.
 */
export function Sprite() {
  return <div className="sprite" aria-hidden="true" dangerouslySetInnerHTML={{ __html: sprite }} />;
}
